/**
 * Group category → display label. Values match `public.group_category`
 * (backend/supabase/migrations/20260930120100_groups_schema.sql); labels are the
 * "Chip / eyebrow text" column from docs/groups/COMPONENTS-COPY.md §0
 * (`CategoryLabel`) — the SAME text the mobile app shows, so an admin choosing a
 * category sees exactly what a member will see.
 */
export interface GroupCategoryOption {
  value: string
  label: string
}

export const GROUP_CATEGORY_OPTIONS: GroupCategoryOption[] = [
  { value: 'faith', label: 'Faith & Ministry' },
  { value: 'career', label: 'Career & Business' },
  { value: 'fitness', label: 'Health & Fitness' },
  { value: 'arts', label: 'Arts & Music' },
  { value: 'chapter', label: 'City Chapter' },
  { value: 'service', label: 'Service' },
  { value: 'family', label: 'Family' },
  { value: 'class', label: 'Class Chapter' },
  { value: 'other', label: 'Community' },
]

export const categoryLabel = (key: string | null | undefined): string =>
  GROUP_CATEGORY_OPTIONS.find((o) => o.value === key)?.label ?? (key ?? '—')
